import useAd from 'lib/hooks/useAd';
import { Targeting } from 'lib/GoogleAds';
import { AdConfig } from './AdConfig';
import Container from './Container';

export interface AdProps {
  placeholderSize?: Array<number>;
  adConfig: AdConfig<Targeting>;
  className?: string;
  load?: boolean;
}

export default function Ad({
  placeholderSize = [],
  adConfig,
  load = true,
  ...props
}: AdProps): JSX.Element {
  const { isShown, elementId } = useAd(adConfig, load);
  const screenSizes = adConfig.screenSizes || [];

  return (
    <Container
      elementId={elementId}
      placeholderSize={placeholderSize}
      isShown={isShown}
      screenSizes={screenSizes}
      {...props}
    />
  );
}
